export default "__VITE_ASSET__UiKkZSJl__"